import React, { useState } from 'react'
import ButtonWithLoader from './ButtonWithLoader'
import Modal from './Modal'
import { Exercise } from '../types'
import { useDispatch } from 'react-redux'
import { DELETE_EXERCISE } from '../redux/exercisesReducer'
import { useParams } from 'react-router-dom'
interface Props {
  exercise: Exercise
}

const DeleteExerciseButton = ({ exercise }: Props) => {
  const { lessonPlanId } = useParams()
  const [isOpen, setIsOpen] = useState(false)
  const toggleModal = () => setIsOpen(!isOpen)
  const dispatch = useDispatch()
  const handleDelete = () => {
    dispatch(DELETE_EXERCISE({ lessonPlanId: Number(lessonPlanId), exerciseId: exercise.id }))
    toggleModal()
  }

  return (
    <>
      <ButtonWithLoader onClick={toggleModal} customClass="!w-24 !h-10 bg-red-600" label="Delete" />
      <Modal isOpen={isOpen} toggleModal={toggleModal}>
        <div className="bg-white rounded-xl p-4 w-[500px] h-[fit-content] mt-20">
          <div className="text-18 font-semibold">Delete Exercise</div>
          <div className="h-4" />
          <div className="text-14 font-medium">Are you sure you want to delete this exercise?</div>
          <div className="h-4" />
          <div className="flex justify-end">
            <ButtonWithLoader onClick={handleDelete} customClass="!w-24 !h-10 bg-red-600" label="Delete" />
          </div>
        </div>
      </Modal>
    </>
  )
}

export default DeleteExerciseButton
